module.exports = __webpack_public_path__ + "static/media/webchat.ee4a7544.svg";